import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { valueProps } from '@/mocks/smart-farm';

export default function ValueProps() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="客户价值"
          title="为农业经营创造可持续价值"
          subtitle="面向不同参与主体，让数字化能力转化为可感知、可衡量的经营改善。"
        />

        <Reveal className="mt-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {valueProps.map((value) => (
              <div
                key={value.audience}
                className="flex items-start gap-5 p-6 rounded-lg bg-background-100 border border-background-200"
              >
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 shrink-0">
                  <i className={`${value.icon} text-2xl`}></i>
                </div>
                <div>
                  <h3 className="font-heading font-bold text-foreground-950 text-xl">{value.audience}</h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{value.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}